'use client';

import { useEffect, useState } from 'react';
import { useHandleError } from '@/hooks/useHandleError';
import { apiFetch } from '@/lib/api/apiClient';
import { StoriesResponse, StoriesWithDetailEyecatches } from '@/types/stories';
import ImageAdaptive from '@/components/ImageAdaptive';
import { NoData } from '@/components/NoData';
import ServiceHeader from '@/components/layout/service/ServiceHeader';
import StoriesListUnit from '@/(routers)/stories/list/components/unit/StoriesListUnit';

export default function StoriesList() {
    const { handleError, clearError } = useHandleError();
    const [isProcessing, setIsProcessing] = useState(false);
    const [storiesData, setStoriesData] = useState<StoriesWithDetailEyecatches[] | null>(null);

    useEffect(() => {
        (async () => {
            try {
                clearError();
                setIsProcessing(true);
                const data: StoriesResponse = await apiFetch(`/stories`);
                setStoriesData(data.stories_list);
            } catch (error: unknown) {
                handleError(error);
            } finally {
                setIsProcessing(false);
            }
        })();
    }, []);

    return (
        <>
            <ServiceHeader title="STORIES." />
            <div className="flex justify-center w-full mt-5 pb-12">
                <div className="flex w-full md:w-[98%] justify-center items-start">
                    {isProcessing ? (
                        <ImageAdaptive src="/images/common/loading.svg" baseWidth={40} breakpoints={{ md: 50 }} />
                    ) : (
                        <>
                            {storiesData && storiesData.length > 0 ? (
                                <div className="w-full md:w-[98%] 2xl:w-[85%] mx-auto">
                                    {storiesData.map((data) => (
                                        <div key={data.id} className="py-2">
                                            <div className="py-8 px-2 md:px-8 bg-color-white-base rounded-none md:rounded-lg">
                                                <StoriesListUnit data={data} showMoreButton={true} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <NoData message="ストーリーズが見つかりませんでした。" />
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
